var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"perm-outer"},[_c('b-alert',{staticClass:"perm-text",attrs:{"show":"","variant":"warning"}},[_c('h5',{staticClass:"alert-heading"},[_vm._v("Permission Denied")]),_c('div',[_vm._v(" You don't have permission to view this document. Please contact the law firm or try login again ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }